var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" payment "),(_vm.loadingState)?_c('loader'):_vm._e(),_c('v-btn',{attrs:{"id":"bKash_button","color":"primary"}},[_vm._v("click")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }